module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAH3RSTlMAlqUQMzgF+6GMhEQy7OPYai0J9MfAtqmSdks9JRMPij9uMAAAAHpJREFUKM/N0EcOhDAQRNGaYWzjQJxM6vvfEoERMrh3SIi/fOpFqzCVhMHnMgrL7Kz9Z6Oqgq98BvqX39Zz91rxLQ1pLFUPn5NC0Q376oIYNcTp/QKasupyTjGknAKNiE2WCeIM5fGtUOxnF1jnXNWs1j8ijThbWBxuBGZ8EYFafh/vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-7.png
// module id = KbZR
// module chunks = 1